export default __webpack_public_path__ + "static/media/saifur-rehman.b3e22ce7.jpg";